import { render } from "./References.vue?vue&type=template&id=e410e542&scoped=true&ts=true"
import script from "./References.vue?vue&type=script&lang=ts"
export * from "./References.vue?vue&type=script&lang=ts"

import "./References.vue?vue&type=style&index=0&id=e410e542&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e410e542"]])

export default __exports__